import { cn } from "../utils";
import { SidebarTrigger, useSidebar } from "./Sidebar";

type Props = {
  title?: string;
  children?: React.ReactNode;
  actionChildren?: React.ReactNode;
  inlineActions?: boolean;
  className?: string;
  actionChildrenClassName?: string;
};

export default function AppHeader({
  title,
  children,
  actionChildren,
  inlineActions = false,
  actionChildrenClassName,
  className,
}: Props) {
  const { isMobile } = useSidebar();

  return (
    <div
      className={cn(
        "flex justify-between",
        inlineActions
          ? "items-center gap-4 px-4 md:px-6"
          : "flex-col md:flex-row md:px-6",
        className,
      )}
    >
      <div
        className={cn(
          "flex min-h-16 min-w-0 items-center",
          !inlineActions && "max-md:px-4",
        )}
      >
        {isMobile && <SidebarTrigger />}
        {title && <h1 className="text-lg font-semibold">{title}</h1>}
        {children}
      </div>
      {actionChildren ? (
        <div
          className={cn(
            "flex min-h-16 items-center gap-4 max-lg:overflow-x-auto",
            !inlineActions && "max-md:px-4",
            actionChildrenClassName,
          )}
        >
          {actionChildren}
        </div>
      ) : null}
    </div>
  );
}
